import { pruneSchema } from '@graphql-tools/utils';
export default class PruneTypes {
    constructor(options) {
        this.options = options;
    }
    transformSchema(schema) {
        return pruneSchema(schema, this.options);
    }
}
//# sourceMappingURL=PruneSchema.js.map